import type { TargetType } from '@atlassiansox/cross-flow-support';
import {
	JiraServiceManagementIcon,
	ConfluenceIcon,
	JiraProductDiscoveryIcon,
} from '@atlaskit/logo';
import { FIRST_PARTY_CCP_PRODUCT_IDS } from '@atlassian/surface-analytics';

export const EXPERIMENT_ID = 'jira_apps_menu_1p_recommendations';

export const JIRA_1P_APPS_MENU_USE_CASE = 'jira1pAppsMenu';

// TODO: is this correct?
export const env = process.env.NODE_ENV === 'production' ? 'prod' : 'staging';

export const JIRA_PRODUCT_DISCOVERY_CCP_PRODUCT_ID =
	FIRST_PARTY_CCP_PRODUCT_IDS[env].jira_product_discovery;
export const CONFLUENCE_CCP_PRODUCT_ID = FIRST_PARTY_CCP_PRODUCT_IDS[env].confluence_cloud;
export const JIRA_SERVICE_MANAGEMENT_CCP_PRODUCT_ID =
	FIRST_PARTY_CCP_PRODUCT_IDS[env].jira_service_management_cloud;

export const RECOMMENDATION_ENTITIES = [
	JIRA_SERVICE_MANAGEMENT_CCP_PRODUCT_ID,
	CONFLUENCE_CCP_PRODUCT_ID,
	JIRA_PRODUCT_DISCOVERY_CCP_PRODUCT_ID,
] as const;

export const EVENT_SOURCE_RECOMMENDATION = 'appsMenu1PRecsSection';
export const EVENT_SOURCE_EXPLORE = 'appsMenu1PExploreSection';

export const COHORT = {
	CONTROL: 'control',
	VARIATION: 'variation',
	NOT_ENROLLED: 'not-enrolled',
} as const;

export const ENTITY_CONFIG_DEFINITION: EntityConfigDefinitionType = {
	[JIRA_SERVICE_MANAGEMENT_CCP_PRODUCT_ID]: {
		title: 'Jira Service Management',
		description: 'Automatically turn tickets into issues',
		icon: JiraServiceManagementIcon,
	},
	[CONFLUENCE_CCP_PRODUCT_ID]: {
		title: 'Confluence',
		description: 'Create one place for all your docs',
		icon: ConfluenceIcon,
	},
	[JIRA_PRODUCT_DISCOVERY_CCP_PRODUCT_ID]: {
		title: 'Jira Product Discovery',
		description: 'Build the right features, the right way',
		icon: JiraProductDiscoveryIcon,
	},
} as const;

export const ENTITY_ID_TO_TARGET_TYPE: Record<RecommendationEntityIdType, TargetType> = {
	[JIRA_PRODUCT_DISCOVERY_CCP_PRODUCT_ID]: 'jira-product-discovery',
	[CONFLUENCE_CCP_PRODUCT_ID]: 'confluence.ondemand',
	[JIRA_SERVICE_MANAGEMENT_CCP_PRODUCT_ID]: 'jira-servicedesk.ondemand',
} as const;

export const PACKAGE_NAME = 'jiraApps1PRecs';
export const TEAM_NAME = 'trailblazer-growth';

export type RecommendationEntityIdType = (typeof RECOMMENDATION_ENTITIES)[number];

export type iconType =
	| typeof JiraServiceManagementIcon
	| typeof ConfluenceIcon
	| typeof JiraProductDiscoveryIcon;

export type EntityConfigType = {
	title: string;
	description: string;
	icon: iconType;
};

export type EntityConfigDefinitionType = {
	[key: RecommendationEntityIdType]: EntityConfigType;
};

export type CohortType = (typeof COHORT)[keyof typeof COHORT];
